var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useState } from "react";
import { AccordionGroupContext } from "./AccordionGroup.context";
var AccordionGroup = forwardRef(function (_a, ref) {
    var children = _a.children, defaultExpanded = _a.defaultExpanded, className = _a.className, style = _a.style, otherProps = __rest(_a, ["children", "defaultExpanded", "className", "style"]);
    var _b = useState(defaultExpanded !== null && defaultExpanded !== void 0 ? defaultExpanded : undefined), activeAccordion = _b[0], setActiveAccordion = _b[1];
    var onToggle = function (id) {
        if (activeAccordion === id) {
            setActiveAccordion(undefined);
        }
        else {
            setActiveAccordion(id);
        }
    };
    var accordionIds = React.Children.map(children, function (child) {
        if (React.isValidElement(child)) {
            var Child = child;
            return Child.props.id;
        }
        return undefined;
    });
    var moveFocusToNextAccordionHeader = function (currentId) {
        var _a;
        if (!accordionIds)
            return;
        var currentIndex = accordionIds.findIndex(function (id) { return id === currentId; });
        var nextIndex = currentIndex + 1;
        if (nextIndex >= accordionIds.length) {
            nextIndex = 0;
        }
        (_a = document.getElementById("".concat(accordionIds[nextIndex], "-header"))) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var moveFocusToPreviousAccordionHeader = function (currentId) {
        var _a;
        if (!accordionIds)
            return;
        var currentIndex = accordionIds.findIndex(function (id) { return id === currentId; });
        var previousIndex = currentIndex - 1;
        if (previousIndex < 0) {
            previousIndex = accordionIds.length - 1;
        }
        (_a = document.getElementById("".concat(accordionIds[previousIndex], "-header"))) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var moveFocusToFirstAccordionHeader = function () {
        var _a;
        if (accordionIds && accordionIds.length > 0) {
            var firstHeaderId = accordionIds[0];
            (_a = document.getElementById("".concat(firstHeaderId, "-header"))) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    var moveFocusToLastAccordionHeader = function () {
        var _a;
        if (accordionIds && accordionIds.length > 0) {
            var lastHeaderId = accordionIds[accordionIds.length - 1];
            (_a = document.getElementById("".concat(lastHeaderId, "-header"))) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    return (React.createElement("div", __assign({}, otherProps, { className: "fr-accordions-group ".concat(className ? className : ""), style: style, ref: ref }),
        React.createElement(AccordionGroupContext.Provider, { value: {
                moveFocusToNextAccordionHeader: moveFocusToNextAccordionHeader,
                moveFocusToPreviousAccordionHeader: moveFocusToPreviousAccordionHeader,
                moveFocusToFirstAccordionHeader: moveFocusToFirstAccordionHeader,
                moveFocusToLastAccordionHeader: moveFocusToLastAccordionHeader,
            } }, React.Children.map(children, function (child) {
            if (React.isValidElement(child)) {
                var childWithProps_1 = child;
                return React.cloneElement(childWithProps_1, {
                    expanded: activeAccordion === childWithProps_1.props.id,
                    onToggle: function () { return onToggle(childWithProps_1.props.id); },
                });
            }
            return null;
        }))));
});
export default AccordionGroup;
